import React from 'react';

import UFOLoadHold from '@atlaskit/react-ufo/load-hold';

import { QueryInterop as Query } from '@confluence/apollo-relay-interop/entry-points/QueryInterop';

import { PageSubscriber } from '@confluence/page-context';
import { Attribution } from '@confluence/error-boundary/entry-points/Attribution';
import { ErrorBoundary } from '@confluence/error-boundary/entry-points/ErrorBoundary';
import { expValEquals } from '@confluence/feature-experiments';

import { CustomHeaderFooterComponent } from './CustomHeaderFooterComponent';
import { CustomHeaderAndFooterQuery } from './CustomHeaderAndFooterQuery.graphql';
import type {
	CustomHeaderAndFooterQuery as QueryType,
	CustomHeaderAndFooterQueryVariables as QueryVariablesType,
} from './__types__/CustomHeaderAndFooterQuery';

type CustomHeaderFooterProps = {
	type: 'header' | 'footer';
};

export function CustomHeaderFooter({ type }: CustomHeaderFooterProps) {
	return (
		<ErrorBoundary attribution={Attribution.BACKBONE}>
			<PageSubscriber>
				{({ spaceKey, contentId }) => (
					<Query<QueryType, QueryVariablesType>
						/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
						query={CustomHeaderAndFooterQuery}
						variables={{ spaceKey }}
					>
						{({ loading, error, data }) => {
							const settings: any = data?.space?.settings?.customHeaderAndFooter?.[type];

							if (loading || error || !settings?.html) {
								return null;
							}

							return (
								<>
									<UFOLoadHold
										name="custom-header-footer-contents"
										hold={
											expValEquals(
												'ufo-experimental-custom-header-footer-confluence',
												'isEnabled',
												true,
											) && loading
										}
									/>
									<CustomHeaderFooterComponent
										spaUnfriendlyMacros={settings.spaUnfriendlyMacros}
										type={type}
										css={settings.css}
										js={settings.js}
										html={settings.html}
										key={contentId}
									/>
								</>
							);
						}}
					</Query>
				)}
			</PageSubscriber>
		</ErrorBoundary>
	);
}
